import axios from 'axios';

import querystring from 'querystring';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async retriveAccountUsers(context, data = {}) {
      try {
        const users = await axios.get(`/verify/account-users?${data.query ? querystring.stringify(data.query) : ''}`, { withCredentials: true });
        return users.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
